// extracted by mini-css-extract-plugin
export default {"container":"FailedRenewBubble_container","alertIcon":"FailedRenewBubble_alertIcon","text":"FailedRenewBubble_text","closeButton":"FailedRenewBubble_closeButton"};